import { createSlice } from 'redux-starter-kit'

function timestampsChanged(state, action) {
  const { timestamps, id } = action.payload
  timestamps.sort()
  return ({ ...state, [id]: timestamps })
}


const iceDrift = createSlice({
  slice: 'iceDrift',
  initialState: {
    timestamps: {}
  },
  reducers: {
    timestampsChanged
  }
})

export default iceDrift



// WEBPACK FOOTER //
// ./src/redux/iceDriftDuck.js